import { ErrorMessage, Field } from 'formik';
import { Col, Form, FormControl, Row } from 'react-bootstrap';
import { FormLabel, FormStepHeader } from '../../../components/forms';
import { genderOptions, gradeLevelOptions } from '../../../utils/consts';
import { StepProps } from '../AddChild';

export const BasicInfoForm = ({ touched, errors }: StepProps) => {
  return (
    <>
      <FormStepHeader title="Basic Info" className="mb-3" />
      <Row>
        <Col
          xs={6}
          className="pe-1"
        >
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="first_name"
          >
            <FormLabel required>First Name</FormLabel>
            <Field
              name="first_name"
              type="text"
              as={Form.Control}
              isInvalid={touched.first_name && !!errors.first_name}
              aria-required
            />
            <ErrorMessage name="first_name">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>
        </Col>
        <Col
          xs={6}
          className="ps-1"
        >
          <Form.Group
            className="mb-lg-3 mb-1"
            controlId="last_name"
          >
            <FormLabel required>Last Name</FormLabel>
            <Field
              name="last_name"
              type="text"
              as={Form.Control}
              isInvalid={touched.last_name && !!errors.last_name}
              aria-required
            />
            <ErrorMessage name="last_name">
              {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
            </ErrorMessage>
          </Form.Group>
        </Col>
      </Row>

      <Form.Group
        className="mb-lg-3 mb-1"
        controlId="dob"
      >
        <FormLabel required>Date of Birth</FormLabel>
        <Field
          name="dob"
          type="date"
          as={Form.Control}
          isInvalid={touched.dob && !!errors.dob}
          aria-required
        />
        <ErrorMessage name="dob">
          {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
        </ErrorMessage>
      </Form.Group>

      <Form.Group
        className="mb-lg-3 mb-1"
        controlId="grade_level"
      >
        <FormLabel required>Grade Level</FormLabel>
        <Field
          name="grade_level"
          as={Form.Select}
          options={['2', '3']}
          placeholder="Select"
          isInvalid={touched.grade_level && !!errors.grade_level}
          aria-required
        >
          <option>Select</option>
          {gradeLevelOptions.map((opt) => (
            <option
              value={opt}
              key={opt}
            >
              {opt}
            </option>
          ))}
        </Field>
        <ErrorMessage name="grade_level">
          {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
        </ErrorMessage>
      </Form.Group>

      <Form.Group
        className="mb-lg-3 mb-1"
        controlId="gender"
      >
        <FormLabel required>Gender</FormLabel>
        <Field
          name="gender"
          as={Form.Select}
          options={['2', '3']}
          placeholder="Select"
          isInvalid={touched.gender && !!errors.gender}
          aria-required
        >
          <option>Select</option>
          {genderOptions.map((opt) => (
            <option
              value={opt.value}
              key={opt.value}
            >
              {opt.name}
            </option>
          ))}
        </Field>
        <ErrorMessage name="gender">
          {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
        </ErrorMessage>
      </Form.Group>

      <Form.Group
        className="mb-lg-3 mb-1"
        controlId="origination"
      >
        <FormLabel>Teacher / Classroom</FormLabel>
        <Field
          name="origination"
          as={Form.Control}
          isInvalid={touched.origination && !!errors.origination}
        />
        <ErrorMessage name="origination">
          {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
        </ErrorMessage>
      </Form.Group>
    </>
  );
};
